import { NgModule } from '@angular/core';
import { DoblesComponent } from './components/dobles/dobles.component';
import { MainComponent } from './main.component';
import { RouterModule } from '@angular/router';
import { CarterVencidaRoutingModule } from './cartera-vencida.routing.module';
import { MatFormFieldModule, MatDatepickerModule, MatInputModule, MatMenuModule, MatIconModule, MatCardModule, MatSelectModule, MatButtonModule, MatButtonToggleModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPaginationModule } from 'ngx-pagination';
import { SortPipe } from './pipes/sort.pipe';

@NgModule({
    declarations:[
        DoblesComponent,
        MainComponent,
        SortPipe
    ],
    imports:[
        RouterModule,
        CarterVencidaRoutingModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        MatMenuModule,
        MatIconModule,
        MatCardModule,
        MatSelectModule,
        NgxPaginationModule,
        MatButtonModule,
        MatButtonToggleModule
    ],
    exports:[],
    entryComponents:[],
})

export class CarteraVencidaModule{}